import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { protectedResources } from '../b2c-config';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SUAService {
  public serviceKeyStatus = new BehaviorSubject<string>('');

  constructor(private http: HttpClient) { }
  
  public getUserServiceKeyStatus() {
    return this.http.get(`${protectedResources.etlApi.endpoint}api/UserManagement/ServiceKeyInfo`);
  } 

  public sendServiceUserKey(file) {
    return this.http.post(`${protectedResources.realizerApi.endpoint}api/ServiceUserAccess/UploadServiceKey`, file);
  } 
  
}
